import React, { memo } from "react";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@material-ui/core/styles";
import { Grid, ToggleButtonGroup, ToggleButton } from "./";

const useStyles = makeStyles({
  toggleButton: {
    flex: 1,
  },
  buttonGroup: {
    width: "100%",
  },
  badge: {
    position: "absolute",
    top: 0,
    right: 0,
  },
});

function TabToggle({ readOnly, onTabChange, activeTab, tabs }) {
  const { t } = useTranslation();
  const classes = useStyles();

  if (readOnly) return "";

  const onChange = (_, tab) => {
    if (tab) {
      onTabChange(null, tab);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs>
        <ToggleButtonGroup
          data-test-id="master-template-voice-active-tab-toggle"
          size="small"
          color="primary"
          onChange={onChange}
          value={activeTab}
          exclusive
          fullWidth
          className={classes.buttonGroup}
        >
          {tabs.map(({ value, label }) => (
            <ToggleButton value={value} className={classes.toggleButton}>
              {t(label)}
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Grid>
    </Grid>
  );
}

export default memo(TabToggle);
